import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/warning.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4aa81f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "warning"
  })
], -1))
const _hoisted_3 = { class: "error-title" }
const _hoisted_4 = { class: "error-subtitle" }
const _hoisted_5 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("UnexpectedError-title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("UnexpectedError--generic-message")), 1)
    ])
  ]))
}